import { useEffect, useState } from "react";
import { Sun, Cloud, CloudRain, CloudLightning, CloudSnow, CloudFog } from "lucide-react";

const codeInfo = (c) => {
  if (c === 0) return { icon: Sun, label: "Ensoleillé" };
  if ([1, 2, 3].includes(c)) return { icon: Cloud, label: "Nuageux" };
  if ([45, 48].includes(c)) return { icon: CloudFog, label: "Brouillard" };
  if ([51, 53, 55, 61, 63, 65, 80, 81, 82].includes(c)) return { icon: CloudRain, label: "Pluie" };
  if ([95, 96, 99].includes(c)) return { icon: CloudLightning, label: "Orage" };
  if ([71, 73, 75, 77, 85, 86].includes(c)) return { icon: CloudSnow, label: "Neige" };
  return { icon: Cloud, label: "Météo" };
};

export function WeatherWidget({ lat, lng, city }) {
  const [w, setW] = useState(null);
  useEffect(() => {
    if (lat == null || lng == null) return;
    let ok = true;
    fetch(`https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lng}&current=temperature_2m,weather_code`)
      .then((r) => r.json())
      .then((j) => { if (ok && j.current) setW(j.current); })
      .catch(() => {});
    return () => { ok = false; };
  }, [lat, lng]);
  if (!w) return null;
  const info = codeInfo(w.weather_code);
  const Icon = info.icon;
  return (
    <div data-testid="weather-widget" className="mb-4 flex items-center gap-3 rounded-2xl bg-gradient-to-r from-[#1A1A1A] to-[#2A322C] text-white px-4 py-3">
      <Icon className="w-8 h-8 text-[#F26419]" strokeWidth={2} />
      <div className="flex-1">
        <div className="font-head font-black text-2xl leading-none">{Math.round(w.temperature_2m)}°C</div>
        <div className="text-xs text-white/70">{info.label}{city ? ` · ${city}` : ""}</div>
      </div>
    </div>
  );
}
